export default __webpack_public_path__ + "static/media/ico-pension.bcfabd79.svg";